import React from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppFloat = ({ phone }) => {
  if (!phone) return null;
  const cleaned = phone.replace(/[^\d]/g, "");
  return (
    <a
      href={`https://wa.me/${cleaned}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#0A1128] text-[#D4AF37] text-xs uppercase tracking-[0.2em] px-4 py-2 rounded-sm border border-[#D4AF37]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden sm:block">
        Chat with us
      </span>
      <span className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] text-white shadow-2xl group-hover:scale-110 transition-transform duration-300">
        <MessageCircle size={26} />
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      </span>
    </a>
  );
};

export default WhatsAppFloat;
